import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

export const getPostfixByActualsValueType = (valueType: ActualsValueTypes) => {
  return valueType === 'Ndp' ? '' : valueType
}
